module.exports = __webpack_public_path__ + "img/pena_logo.f1f21cdc.png";